import { render, staticRenderFns } from "./IMAGEDISPLAY.vue?vue&type=template&id=3a36b62f&"
import script from "./IMAGEDISPLAY.vue?vue&type=script&lang=js&"
export * from "./IMAGEDISPLAY.vue?vue&type=script&lang=js&"
import style0 from "./IMAGEDISPLAY.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports